/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/

export default {

    LAST_5_MIN: 5,
    LAST_30_MIN: 30,
    LAST_60_MIN: 60,
    LAST_3_HOURS: 180,
    LAST_6_HOURS: 360,
    LAST_12_HOURS: 720,
    LAST_24_HOURS: 1440,
    LAST_3_DAYS: 4320,
    LAST_7_DAYS: 10080,
    LAST_14_DAYS: 20160,
    LAST_30_DAYS: 43200,

    BLOCKCHAIN_STEP_STAGE_PROPOSAL: 1000,
    BLOCKCHAIN_STEP_STAGE_ENDORSEMENT: 2000,
    BLOCKCHAIN_STEP_STAGE_ORDER: 3000,
    BLOCKCHAIN_STEP_STAGE_COMMIT: 4000,

    BLOCKCHAIN_REQUEST_EVENT_TYPE_ENTRY: 1,
    BLOCKCHAIN_REQUEST_EVENT_TYPE_EXIT: 2,
    BLOCKCHAIN_REQUEST_EVENT_TYPE_EXIT_WITH_ERROR: 3,

    KEY_TRACE_OPERATION_TYPE_READ: 1000,
    KEY_TRACE_OPERATION_TYPE_WRITE: 2000,
    KEY_TRACE_OPERATION_TYPE_DELETE: 3000,

    DATA_LATENCY: 60, // 1 minute
      
}